/** One item per non-empty line, so a pasted list lands as items. */
export const splitItems = (draft: string): string[] =>
  draft
    .split('\n')
    .map((t) => t.trim())
    .filter(Boolean)

/** The `add_items` args for typed text; ids are client-generated. */
export const addItemsArgs = (texts: string[]) => ({
  items: texts.map((text) => ({ id: crypto.randomUUID(), text })),
})
